export const TOP_TASKS = {
    kills: 'Подеритесь с кем-нибудь на сервере, чтобы получить очки убийства и смерти.',
    deaths: 'Подеритесь с кем-нибудь на сервере, чтобы получить очки убийства и смерти.',
    break: 'Ломайте блоки, чтобы попасть в топ.',
    place: 'Ставьте больше блоков, чтобы попасть в топ.',
    joins: 'Заходите на сервер чаще, чтобы попасть в топ.',
    messages: 'Общайтесь с другими игроками в чате, чтобы попасть в топ.',
    kd: 'Подеритесь с кем-нибудь на сервере, чтобы получить очки убийства и смерти.',
}
